angular.module('ikeweb.user').service('billingService', [function() {
    // names of test plans, and future non-discount plans
    //var MONTHLY_PLAN = 'SpikeMonthly1999';
    //var YEARLY_PLAN = 'SpikeYearly19900';
    //var YEARLY_PLAN_OBSOLETE = 'SpikeYearly20000';

    var MONTHLY_PLAN_DISCOUNT = 'SpikeMonthly999';
    var YEARLY_PLAN_DISCOUNT = 'SpikeYearly9900';

    function fetchPlan(planId) {
        return Parse.Cloud.run('getPlanDetails', {
            id: planId
        });
    }

    function getMonthlyPlan() {
        return fetchPlan(MONTHLY_PLAN_DISCOUNT);
    }

    function getYearlyPlan() {
        return fetchPlan(YEARLY_PLAN_DISCOUNT);
    }

    function getAvailablePlans() {
        return Parse.Promise.when(getMonthlyPlan(), getYearlyPlan()).then(function(month, year) {
            return [month, year];
        });
    }

    function eligibleForTrial() {
        return Parse.Cloud.run('eligibleForTrial');
    }

    function getActiveSubscription() {
        return Parse.Cloud.run('getActiveSubscription');
    }

    function getUpcomingInvoice() {
        return Parse.Cloud.run('getUpcomingInvoice');
    }

    function getInvoices() {
        return Parse.Cloud.run('getInvoices');
    }

    function subscribe(plan, creditCardToken) {
        return Parse.Cloud.run('subscribe', {
            plan: plan,
            token: creditCardToken,
            trial: false
        });
    }

    function subscribeTrial(plan, creditCardToken) {
        return Parse.Cloud.run('subscribe', {
            plan: plan,
            token: creditCardToken,
            trial: true
        });
    }

    function cancelSubscriptionTrial(subscription) {
        return Parse.Cloud.run('cancelSubscription', {
            subscription: subscription
        });
    }

    function cancelSubscription(subscription) {
        return Parse.Cloud.run('cancelSubscription', {
            subscription: subscription
        });
    }

    function getTrialDaysRemaining() {
        return Parse.Cloud.run('getTrialDaysRemaining');
    }

    function getCurrentCreditCard() {
        return Parse.Cloud.run('getCurrentCreditCard');
    }

    function updateCreditCard(token) {
        return Parse.Cloud.run('updateCreditCard', {
            token: token
        });
    }

    function isOnPremium() {
        return getActiveSubscription()
            .then(function(subscription) {
                return !!subscription;
            });
    }

    function notOnPremiumError() {
        return Parse.Promise.error('NOT_ON_PREMIUM');
    }

    function notOnPremiumErrorIfFalse(value) {
        return value || notOnPremiumError();
    }

    function checkPremium() {
        return isOnPremium().then(notOnPremiumErrorIfFalse, notOnPremiumError);
    }

    return {
        getTrialDaysRemaining: getTrialDaysRemaining,
        getCurrentCreditCard: getCurrentCreditCard,
        updateCreditCard: updateCreditCard,
        cancelSubscription: cancelSubscription,
        cancelSubscriptionTrial: cancelSubscriptionTrial,
        subscribe: subscribe,
        subscribeTrial: subscribeTrial,
        getUpcomingInvoice: getUpcomingInvoice,
        getInvoices: getInvoices,
        getAvailablePlans: getAvailablePlans,
        isOnPremium: isOnPremium,
        checkPremium: checkPremium,
        getActiveSubscription: getActiveSubscription,
        eligibleForTrial: eligibleForTrial
    };
}]).config(['$provide', function($provide) {

    var functionsToCache = [
        'getTrialDaysRemaining',
        'getActiveSubscription',
        'getCurrentCreditCard',
        'getAvailablePlans',
        'getUpcomingInvoice',
        'getInvoices',
        'isOnPremium',
        'checkPremium',
        'eligibleForTrial'
    ];

    var functionsThatFlush = [
        'subscribe',
        'subscribeTrial',
        'updateCreditCard',
        'cancelSubscription',
        'cancelSubscriptionTrial'
    ];

    var functionsToDecorate = functionsToCache.concat(functionsThatFlush);

    $provide.decorator('billingService', ['$delegate', 'qPromiseDecoratorService',
        function($delegate, qPromiseDecoratorService) {
            return qPromiseDecoratorService
                .decorateDelegateWithPromise($delegate, functionsToDecorate);
        }
    ]);

    $provide.decorator('billingService', ['$delegate', 'parseErrorDecoratorService',
        function($delegate, parseErrorDecoratorService) {
            return parseErrorDecoratorService.decorateDelegatePromiseErrors($delegate, functionsToDecorate);
        }
    ]);

    $provide.decorator('billingService', ['$delegate', 'promiseProgressDecoratorService',
        function($delegate, promiseProgressDecoratorService) {
            return promiseProgressDecoratorService
                .decorateDelegateWithProgress($delegate, functionsToDecorate);
        }
    ]);

    $provide.decorator('billingService', ['$delegate', 'cacheDecoratorBuilder', 'userHashService',
        function($delegate, cacheDecoratorBuilder, userHashService) {

            return cacheDecoratorBuilder
                .aCacheDecorator()
                .withTTL(moment.duration(10, 'minutes').asMilliseconds())
                .withHash(userHashService.hash)
                .build()
                .decorateDelegateWithCaching($delegate, functionsToCache, functionsThatFlush);
        }
    ]);

    $provide.decorator('billingService', ['$delegate', 'decoratedPromiseBuilder', 'notificationService',
        function($delegate, decoratedPromiseBuilder, notificationService) {

            return decoratedPromiseBuilder
                .forDelegate($delegate)
                .decorate('subscribe')
                .onSuccess(notificationService.success('NOTIFICATION.BILLING.SUBSCRIPTION.TITLE', 'NOTIFICATION.BILLING.SUBSCRIPTION.CREATE.SUCCESS'))
                .onError(notificationService.error('NOTIFICATION.BILLING.SUBSCRIPTION.TITLE', 'NOTIFICATION.BILLING.SUBSCRIPTION.CREATE.ERROR'))
                .decorate('subscribeTrial')
                .onSuccess(notificationService.success('NOTIFICATION.BILLING.SUBSCRIPTION.TRIAL', 'NOTIFICATION.BILLING.SUBSCRIPTION.CREATE.SUCCESS_TRIAL'))
                .onError(notificationService.error('NOTIFICATION.BILLING.SUBSCRIPTION.TRIAL', 'NOTIFICATION.BILLING.SUBSCRIPTION.CREATE.ERROR'))
                .decorate('cancelSubscription')
                .onSuccess(notificationService.success('NOTIFICATION.BILLING.SUBSCRIPTION.TITLE', 'NOTIFICATION.BILLING.SUBSCRIPTION.CANCEL.SUCCESS'))
                .onError(notificationService.error('NOTIFICATION.BILLING.SUBSCRIPTION.TITLE', 'NOTIFICATION.BILLING.SUBSCRIPTION.CANCEL.ERROR'))
                .decorate('cancelSubscriptionTrial')
                .onSuccess(notificationService.success('NOTIFICATION.BILLING.SUBSCRIPTION.TRIAL', 'NOTIFICATION.BILLING.SUBSCRIPTION.CANCEL.SUCCESS_TRIAL'))
                .onError(notificationService.error('NOTIFICATION.BILLING.SUBSCRIPTION.TRIAL', 'NOTIFICATION.BILLING.SUBSCRIPTION.CANCEL.ERROR'))
                .decorate('updateCreditCard')
                .onSuccess(notificationService.success('NOTIFICATION.BILLING.CARD.TITLE', 'NOTIFICATION.BILLING.CARD.UPDATE.SUCCESS'))
                .onError(notificationService.error('NOTIFICATION.BILLING.CARD.TITLE', 'NOTIFICATION.BILLING.CARD.UPDATE.ERROR'))
                .fork();
        }
    ]);

    $provide.decorator('billingService', ['$delegate', 'loggingDecorator',
        function($delegate, loggingDecorator) {
            return loggingDecorator.decorateDelegateWithLogging($delegate, functionsToDecorate);
        }
    ]);
}]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/billing.service.js
// module id = 153
// module chunks = 0